module.exports = __webpack_public_path__ + "static/media/performance-icon.3a5cfec9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/performance-icon.svg
// module id = 1067
// module chunks = 0